import { SERVICE_ITEMS } from "appLauncher";
import { SectionSubtitle, SectionTitle } from "components/Style";
import styled from "styled-components";

const ServicesSection = styled.section`
  padding: 80px 0;
  overflow-x: hidden;
  background-image: url(/assets/about/bar-background-1.png);
  background-position: center;
  background-size: cover;
`;

const ServicesContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px 0 115px;
`;

// 标题已用全局SectionTitle

const ServicesItems = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 100px;
`;

const ServiceItem = styled.div`
  background-color: #fff;
  padding: 48px 40px 40px 40px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  position: relative;
  width: 320px;
  height: 260px;
  min-width: 320px;
  max-width: 320px;
  min-height: 260px;
  max-height: 260px;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ServiceIconPlaceholder = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 70px;
  height: 70px;
  background: #e3e8f7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #b0b8d0;
`;

const ServiceItemInfo = styled.div`
  position: absolute;
  left: 40px;
  bottom: 32px;
  width: calc(100% - 80px);
`;

const ServiceItemTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
  margin: 0 0 8px 0;
`;

const ServiceTitleUnderline = styled.div`
  width: 36px;
  height: 4px;
  background: linear-gradient(90deg, #2640ed 0%, #4f8cff 100%);
  border-radius: 2px;
  margin-bottom: 15px;
`;

const ServiceItemContent = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  text-align: left;
  margin: 0;
`;

import { useEffect, useState } from "react";

export default function ServicesSectionComponent() {
  // 每秒变更高亮卡片
  const [highlightIndex, setHighlightIndex] = useState(
    () => new Date().getSeconds() % 3
  );
  useEffect(() => {
    const timer = setInterval(() => {
      setHighlightIndex(new Date().getSeconds() % 3);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <ServicesSection>
      <ServicesContainer>
        <SectionTitle>服务优势</SectionTitle>
        <SectionSubtitle>Service Advantages</SectionSubtitle>
        <ServicesItems>
          {SERVICE_ITEMS.map((item, idx) => (
            <ServiceItem
              key={item.title}
              style={{
                ...(idx !== SERVICE_ITEMS.length - 1
                  ? { marginRight: 24 }
                  : {}),
                ...(idx === highlightIndex
                  ? {
                      transform: "scale(1.04)",
                      zIndex: 1,
                      boxShadow: "0 8px 16px rgba(38,64,237,0.12)",
                    }
                  : {}),
              }}
            >
              <ServiceIconPlaceholder>
                <img src={"/assets/about/i-" + (idx + 1) + ".png"} />
              </ServiceIconPlaceholder>
              <ServiceItemInfo>
                <ServiceItemTitle>{item.title}</ServiceItemTitle>
                <ServiceTitleUnderline />
                <ServiceItemContent>{item.content}</ServiceItemContent>
              </ServiceItemInfo>
            </ServiceItem>
          ))}
        </ServicesItems>
      </ServicesContainer>
    </ServicesSection>
  );
}
